module.exports = __webpack_public_path__ + "static/google-play-4c7917389e9747ba52a98a5b4c6682db.png";